export default "__VITE_ASSET__C_Uw382G__"